import React from "react"
import { Dialog, FlatButton, SelectField, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IHolidayPaygroupInstance, IHolidayTemplate, IPayType } from "../../../models"
import * as utils from "../../../helpers/utils"
import * as timeHelper from "../../../helpers/timeHelper"
import AccountStore from "../../../stores/AccountStore"
import moment from "moment"
interface IProps {
  handleSave(holiday: IHolidayPaygroupInstance): void
  handleClose(): void
}
interface IState {
  holidayTemplate: IHolidayTemplate
  errorHolidayTemplate: string
  holidayPayType: IPayType
  errorHolidayPayType: string
}

export default class HolidayPaygroupInstanceDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      holidayTemplate: null,
      errorHolidayTemplate: "",
      holidayPayType: null,
      errorHolidayPayType: ""
    }
    autobind(this)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.holidayTemplate) {
      this.setState({ errorHolidayTemplate: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorHolidayTemplate: "" })
    }

    if (!this.state.holidayPayType) {
      this.setState({ errorHolidayPayType: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorHolidayPayType: "" })
    }

    return isValidate
  }

  handleSave() {
    if (!this.checkValidate()) return
    this.props.handleSave({
      Id: utils.guid(),
      HolidayTemplateId: this.state.holidayTemplate.Id,
      PayTypeId: this.state.holidayPayType.Id
    })
  }

  render() {
    let datesString = ""
    this.state.holidayTemplate && this.state.holidayTemplate.Dates.forEach(date => {
      datesString += `${moment(timeHelper.keepConvertUTCToLocal(date)).format("DD/MM/YYYY")},  `
    })
    return (
      <Dialog
        open
        title={strings.Add_Holiday}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={
          <div>
            <FlatButton
              data-intercom-target={"Btn-CloseHolidayPayGroupInstanceDialog"}
              label={strings.CANCEL}
              secondary={true}
              onTouchTap={this.props.handleClose}
            />
            <FlatButton
              data-intercom-target={"Btn-Save"}
              label={strings.SAVE}
              primary={true}
              onTouchTap={this.handleSave}
            />
          </div>
        }
      >
        <hr />
        <div style={{ paddingLeft: 15, paddingRight: 15 }}>
          <div>
            <SelectField
              data-intercom-target={"HolidayPayGroupInstanceDialog-Select-HolidayTemplate"}
              floatingLabelText={strings.Holiday_Template}
              value={this.state.holidayTemplate}
              onChange={(e, key, payload) => this.setState({ holidayTemplate: payload }, () => this.checkValidate())}
              errorText={this.state.errorHolidayTemplate}
              errorStyle={{ position: "absolute", top: 70 }}
            >
              {AccountStore.getCurrentAccount().HolidayTemplates.map((holidayTemplate, index) =>
                <MenuItem key={index} value={holidayTemplate} primaryText={holidayTemplate.Name} />
              )}
            </SelectField>
            <div>{datesString}</div>
          </div>
          <div style={{ marginTop: 20, height: 40 }}>
            {this.state.holidayTemplate &&
              strings.formatString(strings.Holiday_Template_Select_Note, this.state.holidayTemplate.Name)
            }
          </div>
          <div>
            <SelectField
              data-intercom-target={"HolidayPayGroupInstanceDialog-Select-HolidayPayType"}
              floatingLabelText={strings.Holiday_Pay_Type}
              value={this.state.holidayPayType}
              onChange={(e, key, payload) => this.setState({ holidayPayType: payload }, () => this.checkValidate())}
              errorText={this.state.errorHolidayPayType}
              errorStyle={{ position: "absolute", top: 70 }}
            >
              {AccountStore.getCurrentAccount().PayTypes.map((payType, index) =>
                <MenuItem key={index} value={payType} primaryText={payType.Name} />
              )}
            </SelectField>
          </div>
        </div>
      </Dialog>
    )
  }
}